import axios from 'axios';
import serviceHelper from '../../helpers/functions/service.helper';

async function getMyInvoisDocumentList(query){
    const queryString = serviceHelper.queryString(query);
    const documentsResponse = await axios.get(`government/trans/document/list?${queryString}`, { withCredentials : true, });
    return documentsResponse?.data;
}

async function getMyInvoisSubmissionList(query){
    const queryString = serviceHelper?.queryString(query);
    const submissionResponse = await axios?.get(`government/trans/submission/list?${queryString}`, { withCredentials : true, });
    return submissionResponse?.data;
}

async function fetchSubmittedDocument(document_id){
    const documentResponse = await axios.get(`government/trans/document/${document_id}`, { withCredentials : true, });
    return documentResponse?.data;
}

async function fetchDocumentLine(params){
    const documentLineResponse = await axios?.post(`government/trans/document_line/list`, params, { withCredentials : true, });
    return documentLineResponse?.data;
}

async function submitConsolidateInvoiceDocument({ park_id, document_type, ticket_ids = [], form_value = {}, }){
    const params = { park_id, document_type, ticket_ids, ...form_value};
    const submitConsolidateInvoiceDocumentResponse = await axios.post(`government/lhdn/ticket/consolidate/submit`, params, { withCredentials : true, });
    return submitConsolidateInvoiceDocumentResponse?.data;
}

async function fetchSelectedTickets(params){
    const ticketResponse = await axios?.post(`government/trans/ticket/listing`, params, { withCredentials : true, });
    return ticketResponse?.data;
}

export default {
    getMyInvoisDocumentList,
    getMyInvoisSubmissionList,
    fetchSubmittedDocument,
    fetchDocumentLine,
    submitConsolidateInvoiceDocument,
    fetchSelectedTickets,
}